// Auto-generated by scripts/import-ios-levels.mjs — do not edit by hand.
// Regenerate with: `node scripts/import-ios-levels.mjs`.

import type { LevelRegistryEntry } from './loadLevel'

export const GENERATED_LEVEL_REGISTRY: readonly LevelRegistryEntry[] = [
  {
    "id": "TUTORIAL",
    "displayName": "Basic Training",
    "filename": "tutorial_level.json",
    "description": "Learn the core skills of an air traffic controller.",
    "pin": {
      "latitude": 39.4529939564034,
      "longitude": -74.57143237470927
    },
    "isFree": true
  },
  {
    "id": "EHAM",
    "displayName": "Amsterdam Schiphol",
    "filename": "eham_level.json",
    "description": "Amsterdam Airport Schiphol, Netherlands",
    "pin": {
      "latitude": 52.308613,
      "longitude": 4.763889
    },
    "isFree": false
  },
  {
    "id": "PANC",
    "displayName": "Anchorage — Ted Stevens",
    "filename": "panc_level.json",
    "description": "Ted Stevens Anchorage International — a 24/7 cargo hub at the head of Cook Inlet, ringed by the Chugach Range to the east and the Talkeetna Mountains to the north. FedEx, UPS, and Atlas heavies on the Asia-to-Americas freight bridge; medical helicopters between the Bowl and the bush. Three runways; high terrain on every side.",
    "pin": {
      "latitude": 61.1744,
      "longitude": -149.9961
    },
    "isFree": false
  },
  {
    "id": "AVL",
    "displayName": "Asheville Regional",
    "filename": "avl_level.json",
    "description": "Asheville Regional Airport in the Blue Ridge Mountains",
    "pin": {
      "latitude": 35.4361,
      "longitude": -82.542
    },
    "isFree": false
  },
  {
    "id": "ATH",
    "displayName": "Athens",
    "filename": "athens_level.json",
    "description": "Athens Eleftherios Venizelos sits on the Attic plain east of the city, with twin parallel runways and the Aegean's island scatter on approach. The Etesian winds blow from the north most of the year, so 03 is your default runway pair.",
    "pin": {
      "latitude": 37.9364,
      "longitude": 23.9445
    },
    "isFree": false
  },
  {
    "id": "ATL",
    "displayName": "Atlanta Hartsfield-Jackson",
    "filename": "atl_level.json",
    "description": "The world's busiest airport by passenger volume. Manage five parallel east-west runways, dual arrival streams onto 26R and 27L, departures off 26L and 27R, plus GA traffic at Peachtree DeKalb and Charlie Brown Field.",
    "pin": {
      "latitude": 33.6367,
      "longitude": -84.4279
    },
    "isFree": false
  },
  {
    "id": "BCN",
    "displayName": "Barcelona El Prat",
    "filename": "barcelona_level.json",
    "description": "Barcelona El Prat sits where the Llobregat meets the Mediterranean. Twin parallel runways with the sea to the southeast and the Collserola ridge plus Pyrenees foothills to the northwest. Sea-config (24L/R) is the prevailing flow; Mountain-config (06L/R) flips the airport in easterly winds.",
    "pin": {
      "latitude": 41.29694,
      "longitude": 2.07833
    },
    "isFree": false
  },
  {
    "id": "BOS_MHT",
    "displayName": "Boston Approach",
    "filename": "bos_level.json",
    "description": "Control a busy airspace with traffic for Boston Logan and the nearby Manchester Regional airport.",
    "pin": {
      "latitude": 42.3663872051384,
      "longitude": -71.00969861805946
    },
    "isFree": false
  },
  {
    "id": "ORD",
    "displayName": "Chicago O'Hare",
    "filename": "ord_level.json",
    "description": "Chicago's massive Class B airspace features O'Hare with 8 runways, nearby Midway, and GA traffic from Chicago Executive threading through.",
    "pin": {
      "latitude": 41.9769,
      "longitude": -87.9081
    },
    "isFree": false
  },
  {
    "id": "KDEN",
    "displayName": "Denver",
    "filename": "kden_level.json",
    "description": "Denver International Airport in Colorado",
    "pin": {
      "latitude": 39.85962198273638,
      "longitude": -104.67586608445919
    },
    "isFree": false
  },
  {
    "id": "DXB",
    "displayName": "Dubai Emirates",
    "filename": "dubai_level.json",
    "description": "Control the airspace of the Emirates. Manage the relentless stream of A380s and B777s at Dubai International (DXB) while handling cargo traffic at the growing Dubai World Central (DWC). Use the 'FN' waypoints to sequence traffic for the parallel 30 approaches.",
    "pin": {
      "latitude": 25.2528,
      "longitude": 55.3644
    },
    "isFree": true
  },
  {
    "id": "KGCN",
    "displayName": "Grand Canyon",
    "filename": "kgcn_level.json",
    "description": "Grand Canyon National Park Airport in the scenic Arizona highlands",
    "pin": {
      "latitude": 35.9524,
      "longitude": -112.147
    },
    "isFree": true
  },
  {
    "id": "HKG",
    "displayName": "Hong Kong",
    "filename": "hongkong_level.json",
    "description": "Hong Kong International on Chep Lap Kok — twin parallel runways on a man-made island, with Lantau's 3,000 ft peaks 2 NM south, dense Pearl River Delta traffic to the west, and Macau just 35 NM SW.",
    "pin": {
      "latitude": 22.308,
      "longitude": 113.9185
    },
    "isFree": false
  },
  {
    "id": "INN",
    "displayName": "Innsbruck",
    "filename": "innsbruck_level.json",
    "description": "Innsbruck sits in the Inn Valley between the Karwendel and Tux Alps. Single runway, dramatic terrain, curving visual approaches. The mountains rule out southern exits — plan accordingly.",
    "pin": {
      "latitude": 47.260208,
      "longitude": 11.343742
    },
    "isFree": false
  },
  {
    "id": "JNB",
    "displayName": "Johannesburg O.R. Tambo",
    "filename": "johannesburg_level.json",
    "description": "O.R. Tambo sits at 5,558 ft on the Highveld plateau. Hot-and-high performance constraints, twin parallel runways, with Lanseria as the busy GA satellite to the northwest.",
    "pin": {
      "latitude": -26.139167,
      "longitude": 28.246111
    },
    "isFree": false
  },
  {
    "id": "HKO",
    "displayName": "Kona, Hawaii",
    "filename": "kona_level.json",
    "description": "Ellison Onizuka Kona International Airport at Keahole",
    "pin": {
      "latitude": 19.7388,
      "longitude": -156.0456
    },
    "isFree": false
  },
  {
    "id": "LHR",
    "displayName": "London",
    "filename": "lhr_level.json",
    "description": "London, Gatwick and others",
    "pin": {
      "latitude": 51.46906276222269,
      "longitude": -0.4551838404405598
    },
    "isFree": false
  },
  {
    "id": "LAX",
    "displayName": "Los Angeles Basin",
    "filename": "lax_level.json",
    "description": "LAX's four parallel runways plus the full LA Basin: Burbank, Van Nuys, John Wayne and Long Beach. The most complex US airspace in the game — if you can run this one, you can run anything.",
    "pin": {
      "latitude": 33.9425,
      "longitude": -118.4081
    },
    "isFree": false
  },
  {
    "id": "VNLK",
    "displayName": "Lukla — Tenzing-Hillary",
    "filename": "lukla_level.json",
    "description": "Land at Tenzing-Hillary Airport in the heart of the Khumbu region — the gateway to Everest. A 527-metre runway carved into a Himalayan ridge at 9,334 ft, no go-around possible on final, and 8,000-foot mountain walls in every direction. Light aircraft and helicopters only. The hardest airport in the world to fly into, now in your radar.",
    "pin": {
      "latitude": 27.6878,
      "longitude": 86.7297
    },
    "isFree": false
  },
  {
    "id": "MAD",
    "displayName": "Madrid Barajas",
    "filename": "madrid_level.json",
    "description": "Madrid Barajas is Iberia's hub — four runways on the Castilian plateau at 2,000 ft elevation, segregated landing/takeoff pairs. Configuración Norte runs north-flow (default); Configuración Sur flips the airport when the tailwind hits 10 knots.",
    "pin": {
      "latitude": 40.47222,
      "longitude": -3.56083
    },
    "isFree": false
  },
  {
    "id": "VABB",
    "displayName": "Mumbai International",
    "filename": "vabb_level.json",
    "description": "Welcome to Mumbai (BOM). Manage the high-density traffic of India's financial capital. You must handle crossing runway operations (09/27 & 14/32) while keeping heavy jets separated from the VFR traffic at the adjacent Juhu Aerodrome (VAJJ).",
    "pin": {
      "latitude": 19.0887,
      "longitude": 72.8679
    },
    "isFree": false
  },
  {
    "id": "MUN",
    "displayName": "Munich",
    "filename": "munich_level.json",
    "description": "An efficient airport in the South of Germany",
    "pin": {
      "latitude": 48.354014104343456,
      "longitude": 11.783188283719198
    },
    "isFree": false
  },
  {
    "id": "EWR",
    "displayName": "Newark Liberty",
    "filename": "ewr_level.json",
    "description": "Newark is a busy Class B airspace, sharing skies with nearby Caldwell airport.",
    "pin": {
      "latitude": 40.6925,
      "longitude": -74.1687
    },
    "isFree": false
  },
  {
    "id": "MCO",
    "displayName": "Orlando International",
    "filename": "mco_level.json",
    "description": "Orlando is a busy Class B airspace and gateway to Florida's theme parks, sharing skies with Orlando Executive and Palm Beach International to the south.",
    "pin": {
      "latitude": 28.4294,
      "longitude": -81.309
    },
    "isFree": false
  },
  {
    "id": "KIX",
    "displayName": "Osaka Kansai",
    "filename": "kansai_level.json",
    "description": "Kansai sits on a 4 km × 1.25 km artificial island in Osaka Bay — twin parallel runways, no terrain on the field, but the Rokko range to the northeast and Awaji Island to the west constrain the missed-approach paths.",
    "pin": {
      "latitude": 34.4347,
      "longitude": 135.244
    },
    "isFree": false
  },
  {
    "id": "CDG",
    "displayName": "Paris",
    "filename": "cdg_level.json",
    "description": "Charles de Gaulle, Orly and Le Bourget",
    "pin": {
      "latitude": 49.009724,
      "longitude": 2.547778
    },
    "isFree": false
  },
  {
    "id": "KPHX",
    "displayName": "Phoenix",
    "filename": "kphx_level.json",
    "description": "Phoenix Sky Harbor International, Luke Air Force Base, and Scottsdale Airport serving the Phoenix metropolitan area",
    "pin": {
      "latitude": 33.4343,
      "longitude": -112.0116
    },
    "isFree": false
  },
  {
    "id": "SXM",
    "displayName": "Princess Juliana International",
    "filename": "sxm_level.json",
    "description": "St. Maarten's famous Princess Juliana airport with dramatic beach approaches and challenging terrain departures",
    "pin": {
      "latitude": 18.044415908544515,
      "longitude": -63.113487919609796
    },
    "isFree": false
  },
  {
    "id": "ZQN",
    "displayName": "Queenstown NZ",
    "filename": "zqn_level.json",
    "description": "Navigate the dramatic mountain terrain around Queenstown's challenging airport",
    "pin": {
      "latitude": -45.0211,
      "longitude": 168.739
    },
    "isFree": false
  },
  {
    "id": "FCO",
    "displayName": "Rome Fiumicino",
    "filename": "rome_level.json",
    "description": "Rome Fiumicino sits where the Tiber meets the Tyrrhenian Sea. Twin parallel runways drive the dominant 16-flow with a crosswind for departures, plus Ciampino as the GA / low-cost satellite to the east. The Apennines climb sharply once you turn inland.",
    "pin": {
      "latitude": 41.80453,
      "longitude": 12.252
    },
    "isFree": false
  },
  {
    "id": "SAN",
    "displayName": "San Diego International",
    "filename": "san_level.json",
    "description": "San Diego airport is a busy SOCAL airport",
    "pin": {
      "latitude": 32.73368835427756,
      "longitude": -117.18967629267075
    },
    "isFree": false
  },
  {
    "id": "GRU",
    "displayName": "São Paulo Guarulhos",
    "filename": "sao_paulo_guarulhos_level.json",
    "description": "Guarulhos is South America's busiest hub — twin parallel runways at 2,459 ft, dense urban approach with Serra do Mar to the southeast and the Atlantic coast at the eastern edge.",
    "pin": {
      "latitude": -23.432075,
      "longitude": -46.469511
    },
    "isFree": false
  },
  {
    "id": "SDL",
    "displayName": "Scottsdale",
    "filename": "sdl_level.json",
    "description": "Scottsdale is a busy general aviation airport serving the Phoenix metropolitan area. Handle a preset sequence of diverse traffic.",
    "pin": {
      "latitude": 33.6229,
      "longitude": -111.9105
    },
    "isFree": false
  },
  {
    "id": "SHD",
    "displayName": "Shenandoah Valley",
    "filename": "shd_level.json",
    "description": "Shenandoah Valley Regional Airport",
    "pin": {
      "latitude": 38.26358815472407,
      "longitude": -78.90052463951126
    },
    "isFree": false
  },
  {
    "id": "WSSS",
    "displayName": "Singapore Changi",
    "filename": "wsss_level.json",
    "description": "Singapore Changi (WSSS), a major Southeast Asia hub. Manage dense long-haul arrivals and regional traffic with RNAV STARs feeding parallel runway operations.",
    "pin": {
      "latitude": 1.3592111111111111,
      "longitude": 103.989325
    },
    "isFree": false
  },
  {
    "id": "N51",
    "displayName": "Solberg",
    "filename": "n51_level.json",
    "description": "Solberg airport in NJ is a great training airport",
    "pin": {
      "latitude": 40.58024063581596,
      "longitude": -74.7348898036327
    },
    "isFree": true
  },
  {
    "id": "SYD",
    "displayName": "Sydney NSW",
    "filename": "syd_level.json",
    "description": "Kingsford Smith Airport is in the beautiful harbor area",
    "pin": {
      "latitude": -33.94897033177034,
      "longitude": 151.18154955118612
    },
    "isFree": false
  },
  {
    "id": "IKA",
    "displayName": "Tehran Imam Khomeini",
    "filename": "ika_level.json",
    "description": "Tehran's main international gateway sits on an arid plateau south of the city, with Mehrabad handling heavy domestic traffic 18nm to the northeast. The Alborz mountains loom to the north.",
    "pin": {
      "latitude": 35.4161,
      "longitude": 51.1522
    },
    "isFree": false
  },
  {
    "id": "KTEX",
    "displayName": "Telluride",
    "filename": "ktex_level.json",
    "description": "Telluride Regional Airport sits at 9,070 feet in the Colorado Rockies, one of the highest airports in North America.",
    "pin": {
      "latitude": 37.95381,
      "longitude": -107.90875
    },
    "isFree": false
  },
  {
    "id": "TEB",
    "displayName": "Teterboro",
    "filename": "teb_level.json",
    "description": "Teterboro is the busiest general aviation airport in the US. Handle a preset sequence of diverse traffic.",
    "pin": {
      "latitude": 40.8501019,
      "longitude": -74.0608333
    },
    "isFree": false
  },
  {
    "id": "HND",
    "displayName": "Tokyo Haneda",
    "filename": "tokyo_haneda_level.json",
    "description": "Haneda is one of the world's busiest airports — four runways over Tokyo Bay with simultaneous parallel and crosswind ops. Wind direction governs which runways are active.",
    "pin": {
      "latitude": 35.552258,
      "longitude": 139.779694
    },
    "isFree": false
  },
  {
    "id": "NRT",
    "displayName": "Tokyo Narita",
    "filename": "narita_level.json",
    "description": "Narita is Tokyo's primary international gateway — twin parallel runways, busy mixed wide-body / narrow-body operations, Pacific Ocean to the east, Boso Peninsula terrain to the south.",
    "pin": {
      "latitude": 35.7647,
      "longitude": 140.3864
    },
    "isFree": false
  },
  {
    "id": "TOL",
    "displayName": "Toledo Ohio",
    "filename": "toledo_level.json",
    "description": "Eugene Kranz airport is a busy executive airport in the midwest.",
    "pin": {
      "latitude": 41.590408170063945,
      "longitude": -83.80359384220924
    },
    "isFree": false
  },
  {
    "id": "CYVR",
    "displayName": "Vancouver International",
    "filename": "cyvr_level.json",
    "description": "Vancouver International Airport on Canada's West Coast. Navigate through SIDs and STARs while managing a mix of international heavy jets, regional traffic, and military aircraft.",
    "pin": {
      "latitude": 49.18331280291923,
      "longitude": -123.17568976017718
    },
    "isFree": false
  },
  {
    "id": "IAD",
    "displayName": "Washington Area",
    "filename": "iad_level.json",
    "description": "Washington area airports are some of the busiest in the world",
    "pin": {
      "latitude": 38.9474564,
      "longitude": -77.4599286
    },
    "isFree": false
  }
] as const
